// extracted by mini-css-extract-plugin
module.exports = {"gamesList":"_0c8ae30"};